/**
 * SpotlightOverlay — a pulsing ring around the target, shown on demand.
 *
 * Deliberately does NOT dim the page. An always-on dimmer read as heavy-handed:
 * it darkens the very content the user is trying to work with, and on a dense
 * table it fights the task rather than helping it. A ring plus a small label is
 * enough to find a control, and it never obscures anything.
 *
 * `pointer-events: none` throughout, so the real click always lands on the real
 * control — the guide can cost visuals, never usability. Portalled to
 * document.body so page overflow/transform contexts can't clip it.
 */

import { createPortal } from 'react-dom';

const PAD = 5;

const SpotlightOverlay = ({ rect, label }) => {
    if (!rect) return null;

    const ring = {
        top: rect.top - PAD,
        left: rect.left - PAD,
        width: rect.width + PAD * 2,
        height: rect.height + PAD * 2,
    };

    /* Label sits above the target when there's room, else below — it's one line,
       so full placement logic would be overkill. */
    const above = rect.top > 44;
    const tag = {
        top: above ? rect.top - 34 : rect.bottom + 10,
        left: Math.max(8, rect.left),
    };

    return createPortal(
        <div className="phg-highlight" aria-hidden="true">
            <div className="phg-highlight__ring" style={ring} />
            {label ? <div className="phg-highlight__label" style={tag}>{label}</div> : null}
        </div>,
        document.body,
    );
};

export default SpotlightOverlay;
